export default function employeesReducer(state=null, action) {
  switch (action.type) {
    case 'employees/load':
      return action.employees;
      case 'employee/load':
      return _.uniqBy([action.employee, ...(state || [])], 'uuid');
    default:
      return state;
  }
}
